module.exports = __webpack_public_path__ + "static/media/sybase.b099cc58.svg";